import React from "react";

import { COMMON_REGEXES } from "../services/validation.service";
import { EventPerformance, timeData } from "../models/models";






const NoPage: React.FC<any> = (props: any) => {

  // const [formSchema, setFormSchema] = React.useState<Schema<QuickFormSchemaMetaType>>({});

  // const [medialist, setMediaList] = React.useState<string[]>([]);

  // React.useEffect(() => {
  //   (async () => {
  //     setMediaList((await HttpService.get('medialist')).body || [])
  //   })();
  // }, [])

  // React.useEffect(() => {
  //  (async () => {
  //   setFormSchema({
  //     day: { type: daynums, attributes: { required: true, range: { min: 1, max: 31 }, default: 'day' }, meta: { quickForm: { placeholder: "Select day..."}} },
  //     month: { type: [...months], attributes: { required: true, default: 'month' } },
  //     year: { type: 'number', attributes: { required: true, range: { min: 2020, max: 2120 } } },
  //     time: { type: [...times], attributes: { required: true, default: 'time' }},
  //     location: { type: 'string', attributes: { required: true } },
  //     thumbnail: { 
  //       type: 'string', 
  //       attributes: { required: false },
  //       meta: {
  //         quickForm: {
  //         }
  //       }
  //     },
  //     description: { 
  //       type: COMMON_REGEXES.COMMON_WRITING, 
  //       attributes: { required: true, strLength: { minLength: 5 }, }, 
  //       meta: { 
  //         quickForm: { 
  //           textArea: true, 
  //           textAreaRows: 4,
  //           placeholder: 'Enter your description here..',
  //           hideErrorMessages: true
  //         }
  //       }
  //     },
  //     website: { type: 'string', attributes: { required: false }},
  //     media: { type: 'string', attributes: { required: false, array: { minLength: 0 }}},
  //     period: { type: [...periods], attributes: { required: true, default: 'period' } },
  //     test: { 
  //       type: 'boolean', 
  //       attributes: { required: true },
  //       meta: {
  //         quickForm: {
  //           CustomInput: MediaPicker,
  //           customInputProps: { mediaList: (await HttpService.get<string[]>('medialist')).body!.filter(filename => acceptedMediaExtensions.image.filter(accepted => filename.toLowerCase().endsWith(accepted)).length || acceptedMediaExtensions.video.filter(accepted => filename.toLowerCase().endsWith(accepted)).length) || [] }
  //         }
  //       }
  //     }
  //   });
  //  })(); 
  // })




  return (
    <div className="pt-16 fan min-h-screen">PAGE MISSING
    </div>
  )
}

export default NoPage;